import { render, staticRenderFns } from "./PersonRongyu.vue?vue&type=template&id=d18fda7c&scoped=true&"
import script from "./PersonRongyu.vue?vue&type=script&lang=js&"
export * from "./PersonRongyu.vue?vue&type=script&lang=js&"
import style0 from "./PersonRongyu.vue?vue&type=style&index=0&id=d18fda7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18fda7c",
  null
  
)

component.options.__file = "PersonRongyu.vue"
export default component.exports